import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaDiarias = '/service/contabilidade/dotacao/'

class ConsultaPrestacaoContasAnualService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value).join() : this.state.adms,
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
        }
        return this.conex.post(urlConsultaDiarias + 'consultaPrestacaoContaAnual/', JSON.stringify(data))
    }
}

export default ConsultaPrestacaoContasAnualService
